import React, { useState } from 'react';
import PartnerRequestsTab from './PartnerRequestsTab';
import SchoolsTab from './SchoolsTab';
import TeachersTab from './TeachersTab';
import InfluencersTab from './InfluencersTab';
import ReferralLinksTab from './ReferralLinksTab';
import CommissionsTab from './CommissionsTab';
import PayoutsTab from './PayoutsTab';
import AnalyticsTab from './AnalyticsTab';
import '../../components/tabs/UserManagement.css';
import './PartnershipManagement.css';

const PartnershipManagementPage = () => {
  const [activeInnerTab, setActiveInnerTab] = useState('partner-requests');

  const tabs = [
    { id: 'partner-requests', label: 'Partner Requests', icon: 'handshake' },
    { id: 'schools', label: 'Schools & Partners', icon: 'account_balance' },
    { id: 'teachers', label: 'Teachers', icon: 'school' },
    { id: 'influencers', label: 'Influencers', icon: 'campaign' },
    { id: 'referral-links', label: 'Referral Links', icon: 'link' },
    { id: 'commissions', label: 'Commissions', icon: 'payments' },
    { id: 'payouts', label: 'Payouts', icon: 'account_balance_wallet' },
    { id: 'analytics', label: 'Analytics', icon: 'bar_chart' },
  ];

  const renderActiveTab = () => {
    switch (activeInnerTab) {
      case 'partner-requests':
        return <PartnerRequestsTab />;
      case 'schools':
        return <SchoolsTab />;
      case 'teachers':
        return <TeachersTab />;
      case 'influencers':
        return <InfluencersTab />;
      case 'referral-links':
        return <ReferralLinksTab />;
      case 'commissions':
        return <CommissionsTab />;
      case 'payouts':
        return <PayoutsTab />;
      case 'analytics':
        return <AnalyticsTab />;
      default:
        return <PartnerRequestsTab />;
    }
  };

  return (
    <div className="section user-management-section partnership-management-page">
      <h2>Partnership Management</h2>
      <p className="partnership-page-subtitle">
        Manage partner requests, schools, education partners, teachers, influencers, referral links, commissions, and payouts.
      </p>

      <div className="user-management-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeInnerTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveInnerTab(tab.id)}
          >
            <span className="material-icons">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {renderActiveTab()}
    </div>
  );
};

export default PartnershipManagementPage;

